import {
  KlearlyCountryAlpha2Code,
  KlearlyCountryAlpha2Codes,
} from "../../../interfaces/klearlyCountryAlpha2Code.enum";

// Only truly unset input defaults to NL (matches onlinePricingTemplateForCountry's
// own unset-country fallback). A genuinely unresolvable code/name returns
// undefined rather than a fake alpha-2 value — the five supported countries are
// the whole allowlist, so anything else really is unresolvable. Callers already
// handle undefined: CountryFlag renders nothing, and onlinePricingTemplateForCountry
// treats it the same as unset (falls through to CardsOnly for a genuinely unknown
// country, same as before, just explicitly instead of by accident).
export const resolveCountryAlpha2 = (
  country?: string
): KlearlyCountryAlpha2Code | undefined => {
  if (!country) return KlearlyCountryAlpha2Code.Netherlands;
  const value = country.trim();
  if (value.length === 2) {
    const code = value.toLowerCase();
    return KlearlyCountryAlpha2Codes.includes(code)
      ? (code as KlearlyCountryAlpha2Code)
      : undefined;
  }
  const name = value.toLowerCase();
  switch (name) {
    case "netherlands":
    case "the netherlands":
    case "holland":
      return KlearlyCountryAlpha2Code.Netherlands;
    case "belgium":
      return KlearlyCountryAlpha2Code.Belgium;
    case "germany":
      return KlearlyCountryAlpha2Code.Germany;
    case "france":
      return KlearlyCountryAlpha2Code.France;
    case "italy":
      return KlearlyCountryAlpha2Code.Italy;
    default:
      return undefined;
  }
};
